export const BASEAPIADDRESS = '/api';
export const BASEDATAVIEWADDRESS = `${BASEAPIADDRESS}/dataviews`;

export const APIURLS = {
    admin: {
        root: `${BASEAPIADDRESS}/admin`,
        updatePageCacheRefreshToken: `${BASEAPIADDRESS}/Admin/UpdatePageCacheRefreshToken`
    },
    adminCustomerRewards: `${BASEAPIADDRESS}/AdminCustomerRewards`,
    address: `${BASEAPIADDRESS}/address`,
    amazonAdmin: {
        root: `${BASEAPIADDRESS}/AmazonAdmin`
    },
    amazonManagement: `${BASEAPIADDRESS}/AmazonManagement`,
    amazonOAuth: {
        root: `${BASEAPIADDRESS}/AmazonOauth`
    },
    amazonProduct: {
        root: `${BASEAPIADDRESS}/AmazonProduct`,
        getByProductId: `${BASEAPIADDRESS}/AmazonProduct/GetByProductID/{{PRODUCTUID}}`,
        getSetupStatus: `${BASEAPIADDRESS}/AmazonProduct/GetSetupStatus`
    },
    attributeDetail: {
        root: `${BASEAPIADDRESS}/AttributeDetail`
    },
    autoSIMBrands: `${BASEAPIADDRESS}/AutoSIMBrands`,
    autoSIMCodeLookup: `${BASEAPIADDRESS}/AutoSimCodeLookup?productId={{PRODUCTUID}}`,
    banners: {
        root: `${BASEAPIADDRESS}/bannercollections`,
        filterable: `${BASEAPIADDRESS}/bannercollections/GetUsingGridRequestModel`,
        model: `${BASEAPIADDRESS}/bannercollections/Model`
    },
    bulkops: {
        product: {
            primaryCategory: `${BASEAPIADDRESS}/bulkproductoperations/SetPrimaryCategory`,
            majorItem: `${BASEAPIADDRESS}/bulkproductoperations/SetMajorItem`,
            buyersGuide: `${BASEAPIADDRESS}/bulkproductoperations/SetBuyersGuide`,
            deliveryDelay: `${BASEAPIADDRESS}/bulkproductoperations/SetDeliveryDelay`,
            relatedItems: `${BASEAPIADDRESS}/bulkproductoperations/SetFacetProductRelated`,
            blockMailOrder: `${BASEAPIADDRESS}/bulkproductoperations/SetBlockMailOrder`,
            restrictStorePickup: `${BASEAPIADDRESS}/bulkproductoperations/SetRestrictStorePickup`,
            deliveryChargesApply: `${BASEAPIADDRESS}/bulkproductoperations/SetDeliveryChargesApply`,
            inventoryTracked: `${BASEAPIADDRESS}/bulkproductoperations/SetInventoryTracked`,
            backorder: `${BASEAPIADDRESS}/bulkproductoperations/SetBackorder`,
            prelaunch: `${BASEAPIADDRESS}/bulkproductoperations/SetPrelaunch`,
            addToCollection: `${BASEAPIADDRESS}/bulkproductoperations/AddToCollection`,
            simStockStatus: `${BASEAPIADDRESS}/bulkproductoperations/SetSimStockStatus`,
            archive: `${BASEAPIADDRESS}/item/bulk/archive`,
            scheduleActivation: `${BASEAPIADDRESS}/item/bulk/schedule-activation`
        },
        openingHours: {
            setOpeningTimes: `${BASEAPIADDRESS}/BulkOpeningHoursOperations/SetOpeningTimes`
        },
        collection: {
            clearCollection: `${BASEAPIADDRESS}/BulkFindAndFilterCollectionOperations/ClearCollection`
        },
        ebayCategory: {
            replace: `${BASEAPIADDRESS}/BulkEbayCategoryOperations/Replace`
        },
        starBuys: {
            deleteItemToItem: `${BASEAPIADDRESS}/BulkStarBuysOperations/DeleteItemToItem`
        }
    },
    buyersguides: {
        root: `${BASEAPIADDRESS}/articleDictionary`,
        filterable: `${BASEAPIADDRESS}/articleDictionary/GetUsingGridRequestModel`,
        model: `${BASEAPIADDRESS}/articleDictionary/Model`
    },
    categories: `${BASEAPIADDRESS}/Categories`,
    checkoutThirdPartyScript: {
        root: `${BASEAPIADDRESS}/CheckoutThirdPartyScript`,
        delete: (id) => `${BASEAPIADDRESS}/CheckoutThirdPartyScript/${id}`
    },
    clEBayAdmin: `${BASEAPIADDRESS}/EbayAdmin`,
    clEbayListed: {
        root: `${BASEAPIADDRESS}/EbayListed`,
        getByProductId: `${BASEAPIADDRESS}/EbayListed/GetByProductId`
    },
    clFlashImage: {
        root: `${BASEAPIADDRESS}/FlashImage`,
        getByProductId: `${BASEAPIADDRESS}/FlashImage/GetByProductID/{{PRODUCTUID}}`
    },
    clickAndCollectConfiguration: `${BASEAPIADDRESS}/clickAndCollectConfiguration`,
    clickAndCollectManagement: `${BASEAPIADDRESS}/ClickAndCollectManagement`,
    clMetapackAdmin: `${BASEAPIADDRESS}/MetapackAdmin`,
    cloudKeyValueStore: {
        root: `${BASEAPIADDRESS}/CloudKeyValueStore`
    },
    cloudPosApi: `${BASEAPIADDRESS}/CloudPosApi`,
    clStockNotify: {
        root: `${BASEAPIADDRESS}/StockNotify`,
        deleteSentByProductId: `${BASEAPIADDRESS}/StockNotify/DeleteSentByProductId`,
        deletePendingByProductId: `${BASEAPIADDRESS}/StockNotify/DeletePendingByProductId`,
        model: `${BASEAPIADDRESS}/StockNotify/Model`
    },
    colourGroup: `${BASEAPIADDRESS}/ColourGroup`,
    colourGroupProduct: {
        root: `${BASEAPIADDRESS}/ColourGroupProduct`,
        getByProductId: `${BASEAPIADDRESS}/ColourGroupProduct/GetByProductId`,
        addToColourGroup: `${BASEAPIADDRESS}/ColourGroupProduct/AddToColourGroup`,
        removeFromColourGroup: `${BASEAPIADDRESS}/ColourGroupProduct/RemoveFromColourGroup`
    },
    configurationAudits: `${BASEAPIADDRESS}/ConfigurationDetails/SiteAudits`,
    configurationDetails: `${BASEAPIADDRESS}/ConfigurationDetails`,
    countryList: `${BASEAPIADDRESS}/CountryList`,
    customStyling: {
        root: `${BASEAPIADDRESS}/CustomStyling`
    },
    customer: {
        root: `${BASEAPIADDRESS}/Customer`,
        updateFromCustomerViewData: `${BASEAPIADDRESS}/Customer/UpdateFromViewData`,
        anonymise: `${BASEAPIADDRESS}/Customer/Anonymise`
    },
    customerManager: `${BASEAPIADDRESS}/CustomerManager`,
    customProductAttributes: {
        root: `${BASEAPIADDRESS}/CustomProductAttributes`,
        model: `${BASEAPIADDRESS}/CustomProductAttributes/Model`,
        byUid: `${BASEAPIADDRESS}/CustomProductAttributes/{{UID}}`
    },
    customProductAttributeDetail: {
        root: `${BASEAPIADDRESS}/CustomProductAttributeDetail`,
        byUid: `${BASEAPIADDRESS}/CustomProductAttributeDetail/{{UID}}`,
        byAttributeID: `${BASEAPIADDRESS}/CustomProductAttributeDetail/GetByAttributeID/{{ATTID}}`,
        model: `${BASEAPIADDRESS}/CustomProductAttributeDetail/Model`
    },
    customProductTemplateDefinitions: {
        root: `${BASEAPIADDRESS}/CustomProductTemplateDefinition`,
        GetEditModel: `${BASEAPIADDRESS}/CustomProductTemplateDefinition/GetEditModel/{{TEMPLATEID}}`
    },
    customProductTemplateMapping: {
        root: `${BASEAPIADDRESS}/CustomProductTemplateMapping`,
        getForTemplateId: `${BASEAPIADDRESS}/CustomProductTemplateMapping/GetAllMappingsForTemplateId/{{TEMPLATEID}}`,
        getForProductId: `${BASEAPIADDRESS}/CustomProductTemplateMapping/GetAllMappingsForProductId/{{PRODUCTID}}`
    },
    cycleschemeRestrictedFacets: `${BASEAPIADDRESS}/CycleschemeRestrictedFacetList`,
    errorPageOptions: {
        root: `${BASEAPIADDRESS}/ErrorPageOptions`
    },
    fileDelete: {
        root: `${BASEAPIADDRESS}/FileDelete`
    },
    fileList: {
        root: `${BASEAPIADDRESS}/FileList`,
        filter: `${BASEAPIADDRESS}/FileList/Filter?folder={FOLDER}&subFolder={SUBFOLDER}`
    },
    fileUpload: `${BASEAPIADDRESS}/FileUpload`,
    googlecategories: `${BASEAPIADDRESS}/GoogleCategories`,
    login: {
        auth: `${BASEAPIADDRESS}/logon/logon/authenticate`,
        superUser: `${BASEAPIADDRESS}/logon/logon/super-user`
    },
    twoFactorAuth: {
        verifyCode: `${BASEAPIADDRESS}/logon/logon/2fa`,
        verifySms: `${BASEAPIADDRESS}/logon/logon/2fa/sms`
    },
    ebayCategories: {
        importToCitrusStore: `${BASEAPIADDRESS}/EbayCategories/ImportToCitrusStore`,
        updateCategories: `${BASEAPIADDRESS}/EbayCategories/UpdateCategories`
    },
    eBayDownloadOrders: {
        root: `${BASEAPIADDRESS}/EbayDownloadOrders`
    },
    ebayItemOptions: {
        root: `${BASEAPIADDRESS}/EbayItemOptions`,
        model: `${BASEAPIADDRESS}/EbayItemOptions/Model`
    },
    eBayListing: {
        root: `${BASEAPIADDRESS}/EbayListing`,
        updateByProduct: `${BASEAPIADDRESS}/EbayListing/UpdateProductListings`
    },
    ebayProduct: {
        root: `${BASEAPIADDRESS}/EbayProduct`,
        getByProductId: `${BASEAPIADDRESS}/EbayProduct/GetByProductId`,
        getSetupStatus: `${BASEAPIADDRESS}/EbayProduct/GetSetupStatus`
    },
    ebayShipToExcluded: {
        root: `${BASEAPIADDRESS}/EbayShipToExcluded`,
        getByTemplateId: `${BASEAPIADDRESS}/EbayShipToExcluded/GetByTemplateId`
    },
    ebayShippingTable: {
        root: `${BASEAPIADDRESS}/EbayShippingTable`,
        filterableByTemplateId: `${BASEAPIADDRESS}/EbayShippingTable/GetForTemplateUsingFilterRequestModel`,
        model: `${BASEAPIADDRESS}/EbayShippingTable/Model`
    },
    ebayTemplates: {
        root: `${BASEAPIADDRESS}/EbayTemplates`,
        filterable: `${BASEAPIADDRESS}/EbayTemplates/GetUsingFilterRequestModel`,
        model: `${BASEAPIADDRESS}/EbayTemplates/Model`
    },
    facetCustomRepeaters: {
        root: `${BASEAPIADDRESS}/FafCustomRepeaters`,
        filterable: `${BASEAPIADDRESS}/FafCustomRepeaters/GetUsingFilterRequestModel`,
        model: `${BASEAPIADDRESS}/FafCustomRepeaters/Model`
    },
    facetFilterDefinitions: `${BASEAPIADDRESS}/FacetFilterDefinition`,
    facetNavigation: {
        root: `${BASEAPIADDRESS}/FacetNavigation`,
        model: `${BASEAPIADDRESS}/FacetNavigation/Model`,
        landingPage: {
            root: `${BASEAPIADDRESS}/FacetNavigation/LandingPage`,
            filter: `${BASEAPIADDRESS}/FacetNavigation/LandingPage/Filter`
        }
    },
    facetProductLink: {
        root: `${BASEAPIADDRESS}/FacetProductLink`,
        getByProductId: `${BASEAPIADDRESS}/FacetProductLink/GetByProductID/{{PRODUCTUID}}`,
        deleteByProductId: `${BASEAPIADDRESS}/FacetProductLink/DeleteByProductId`,
        model: `${BASEAPIADDRESS}/FacetProductLink/Model`
    },
    facetProductRelated: {
        root: `${BASEAPIADDRESS}/facetProductRelated`,
        getByProductId: `${BASEAPIADDRESS}/facetProductRelated/GetByProductID/{{PRODUCTUID}}`
    },
    facets: {
        root: `${BASEAPIADDRESS}/Facet`,
        filterableActivities: `${BASEAPIADDRESS}/Facet/GetActivityFacetsForFilterRequest`,
        filterableDepartments: `${BASEAPIADDRESS}/Facet/GetDepartmentFacetsForFilterRequest`,
        filterableItemGroups: `${BASEAPIADDRESS}/Facet/GetItemGroupFacetsForFilterRequest`,
        filterableMaterials: `${BASEAPIADDRESS}/Facet/GetMaterialFacetsForFilterRequest`,
        filterableDepartmentBrowseFilters: `${BASEAPIADDRESS}/Facet/GetDepartmentBrowseFilterFacetsByLevelAndDefinitionIdForFilterRequest`,
        filterableProductGroupBrowseFilters: `${BASEAPIADDRESS}/Facet/GetProductGroupBrowseFilterFacetsByLevelAndDefinitionIdForFilterRequest`
    },
    faqs: {
        root: `${BASEAPIADDRESS}/FaqTable`
    },
    collectionHomepage: {
        root: `${BASEAPIADDRESS}/CollectionHomepage`
    },
    collections: {
        root: `${BASEAPIADDRESS}/CollectionDefinitions`,
        filterable: `${BASEAPIADDRESS}/CollectionDefinitions/Filter`,
        model: `${BASEAPIADDRESS}/CollectionDefinitions/Model`,
        type: {
            byType: (type) => `${BASEAPIADDRESS}/CollectionDefinitions/Type/${type}`,
            product: `${BASEAPIADDRESS}/CollectionDefinitions/GetProductCollectons`
        },
        item: (id) => ({
            root: `${BASEAPIADDRESS}/CollectionDefinitions/${id}/Item`,
            delete: (itemId) => `${BASEAPIADDRESS}/CollectionDefinitions/${id}/Item/${itemId}`
        }),
        facet: (id) => ({
            root: `${BASEAPIADDRESS}/CollectionDefinitions/${id}/Facet`,
            delete: (facetId) => `${BASEAPIADDRESS}/CollectionDefinitions/${id}/Facet/${facetId}`
        }),
        tag: (id) => `${BASEAPIADDRESS}/CollectionDefinitions/${id}/Tag`,
        parent: {
            root: (id) => `${BASEAPIADDRESS}/CollectionDefinitions/${id}/Parent`,
            deleteAll: (id) => `${BASEAPIADDRESS}/CollectionDefinitions/${id}/Parent/DeleteAll`
        },
        child: {
            root: (id) => `${BASEAPIADDRESS}/CollectionDefinitions/${id}/Child`,
            filter: (id) => `${BASEAPIADDRESS}/CollectionDefinitions/${id}/Child/Filter`
        },
        select: `${BASEAPIADDRESS}/CollectionDefinitions/Select`,
        redirect: `${BASEAPIADDRESS}/CollectionDefinitions/Redirect`,
        delete: (id) => `${BASEAPIADDRESS}/CollectionDefinitions/${id}`
    },
    collectionTags: {
        root: `${BASEAPIADDRESS}/CollectionTags`,
        filterable: `${BASEAPIADDRESS}/CollectionTags/Filter`
    },
    financeProductRangeOperation: {
        createFinanceProducts: `${BASEAPIADDRESS}/financeProductRangeOperation/CreateFinanceProducts`
    },
    financeProduct: {
        root: `${BASEAPIADDRESS}/FinanceProduct`
    },
    financesetup: `${BASEAPIADDRESS}/FinanceSetup`,
    findAndFilterResultStats: `${BASEAPIADDRESS}/FindAndFilterResultStats`,
    findAndFilterURL: `${BASEAPIADDRESS}/FindAndFilterURL`,
    forwardOrderLoaderConfiguration: {
        root: `${BASEAPIADDRESS}/ForwardOrderLoaderConfiguration`
    },
    bannerEntries: {
        root: `${BASEAPIADDRESS}/BannerCollectionEntry`,
        filterableByParentId: `${BASEAPIADDRESS}/BannerCollectionEntry/GetForParentUsingFilterRequestModel`,
        model: `${BASEAPIADDRESS}/BannerCollectionEntry/Model`
    },
    brands: {
        root: `${BASEAPIADDRESS}/brands`,
        filterable: `${BASEAPIADDRESS}/brands/GetUsingGridRequestModel`
    },
    coupons: {
        root: `${BASEAPIADDRESS}/coupon`,
        range: `${BASEAPIADDRESS}/coupon/range`
    },
    generalPages: `${BASEAPIADDRESS}/GeneralPagesTbl`,
    giantCollectionLocations: {
        root: `${BASEAPIADDRESS}/GiantCollectionLocations`,
        updateLatLng: `${BASEAPIADDRESS}/GiantCollectionLocations/UpdateLatitudeLongitude`,
        model: `${BASEAPIADDRESS}/GiantCollectionLocations/Model`
    },
    giantDealers: {
        root: `${BASEAPIADDRESS}/GiantDealers`,
        getByDealerNumber: `${BASEAPIADDRESS}/GiantDealers/GetByDealerNumber`,
        model: `${BASEAPIADDRESS}/GiantDealers/Model`
    },
    integratedPaymentProcessingDetails: `${BASEAPIADDRESS}/IntegratedPaymentProcessingDetails`,
    integratedPaymentProcessingAction: `${BASEAPIADDRESS}/IntegratedPaymentProcessingAction`,
    inventory: {
        root: `${BASEAPIADDRESS}/Inventory`,
        getByProductID: `${BASEAPIADDRESS}/Inventory/GetByProductID/{{PRODUCTUID}}`
    },
    inventoryinfo: {
        root: `${BASEAPIADDRESS}/InventoryInfo`,
        updateSuppressSim: `${BASEAPIADDRESS}/InventoryInfo/UpdateSuppressSimValue/{{RECORDUID}}/{{SUPPRESSSETTING}}`
    },
    item: {
        unarchive: `${BASEAPIADDRESS}/item/{PRODUCT_ID}/unarchive`
    },
    linkCollections: `${BASEAPIADDRESS}/LinkCollection`,
    linkCollectionEntries: {
        root: `${BASEAPIADDRESS}/LinkCollectionEntries`
    },
    localisation: {
        root: `${BASEAPIADDRESS}/Localisation`
    },
    logFromFrontEnd: `${BASEAPIADDRESS}/LogErrorFromFrontEndUI`,
    mailQueue: {
        root: `${BASEAPIADDRESS}/MailQueue`,
        filterable: `${BASEAPIADDRESS}/MailQueue/GetUsingGridRequestModel`
    },
    paymentMethods: {
        root: `${BASEAPIADDRESS}/PaymentMethods`,
        getByName: `${BASEAPIADDRESS}/PaymentMethods/GetByName`
    },
    paymentProcessors: {
        root: `${BASEAPIADDRESS}/PaymentProcessors`,
        filterable: `${BASEAPIADDRESS}/PaymentProcessors/GetUsingFilterRequestModel`,
        getByName: `${BASEAPIADDRESS}/PaymentProcessors/GetByName`
    },
    payPalAuth: {
        root: `${BASEAPIADDRESS}/PayPalAuth`
    },
    payPalConfig: {
        root: `${BASEAPIADDRESS}/PayPalConfiguration`
    },
    productCollectionLink: {
        root: `${BASEAPIADDRESS}/ProductCollectionLink`,
        getByProductId: `${BASEAPIADDRESS}/ProductCollectionLink/GetByProductId`,
        model: `${BASEAPIADDRESS}/ProductCollectionLink/Model`
    },
    products: {
        root: `${BASEAPIADDRESS}/products`,
        getProductUrl: `${BASEAPIADDRESS}/products/getProductUrl`,
        deactivateProduct: `${BASEAPIADDRESS}/products/DeactivateProduct`,
        applyBuilderTemplate: `${BASEAPIADDRESS}/products/ApplyCustomBuilderTemplateToProduct`,
        removeBuilderTemplate: `${BASEAPIADDRESS}/products/RemoveCustomBuilderTemplateFromProduct`,
        removeOldBuilderInfo: `${BASEAPIADDRESS}/products/RemoveOldCustomBuilderFromProduct`
    },
    productSIMManagement: {
        root: `${BASEAPIADDRESS}/productsimmanagement`
    },
    redirect: {
        root: `${BASEAPIADDRESS}/redirect`,
        validate: `${BASEAPIADDRESS}/redirect/validate`,
        product: {
            root: `${BASEAPIADDRESS}/redirect/product`
        },
        nonProduct: {
            filter: `${BASEAPIADDRESS}/redirect/non-product/filter`
        }
    },
    reviews: {
        root: `${BASEAPIADDRESS}/review`
    },
    seasons: `${BASEAPIADDRESS}/season`,
    selectCountry: {
        root: `${BASEAPIADDRESS}/selectCountry`
    },
    selectState: {
        root: `${BASEAPIADDRESS}/selectState`
    },
    simAutomationStatus: `${BASEAPIADDRESS}/SimAutomationStatus`,
    siteDisplayOptions: `${BASEAPIADDRESS}/SiteDisplayOptions`,
    siteDataOptions: {
        root: `${BASEAPIADDRESS}/SiteDataOptions`,
        numbers: `${BASEAPIADDRESS}/SiteDataOptions/Numbers`
    },
    sizeFilterGroup: {
        root: `${BASEAPIADDRESS}/SizeFilterGroup`
    },
    sizeFilterRule: {
        root: `${BASEAPIADDRESS}/SizeFilterRule`,
        model: `${BASEAPIADDRESS}/SizeFilterRule/Model`
    },
    sizeFilterMapper: {
        refreshSizeFilters: `${BASEAPIADDRESS}/SizeFilterMapper/RefreshSizeFilters`
    },
    socialMediaLink: {
        root: `${BASEAPIADDRESS}/SocialMediaLink`
    },
    starBuy: {
        root: `${BASEAPIADDRESS}/StarBuy`
    },
    supplierIntegrationConfig: {
        root: `${BASEAPIADDRESS}/SupplierIntegrationConfig`
    },
    userSiteMessaging: `${BASEAPIADDRESS}/userSiteMessaging`,
    veeqoConfig: {
        root: `${BASEAPIADDRESS}/veeqo`,
        auth: `${BASEAPIADDRESS}/veeqo/auth`
    },
    version: `${BASEAPIADDRESS}/apiversion`,
    views: {
        advancedProductSearch: {
            root: `${BASEDATAVIEWADDRESS}/AdvancedProductSearchView`
        },
        amazonProducts: {
            root: `${BASEDATAVIEWADDRESS}/amazonproductsview`
        },
        backInStock: {
            root: `${BASEDATAVIEWADDRESS}/BackInStockView`,
            csv: `${BASEDATAVIEWADDRESS}/BackInStockView/csv`
        },
        backInStockProduct: {
            root: `${BASEDATAVIEWADDRESS}/BackInStockProductView`,
            pending: `${BASEDATAVIEWADDRESS}/BackInStockProductView/Pending`,
            sent: `${BASEDATAVIEWADDRESS}/BackInStockProductView/Sent`
        },
        backInStockSummary: {
            pending: `${BASEDATAVIEWADDRESS}/BackInStockSummaryView/Pending`,
            sent: `${BASEDATAVIEWADDRESS}/BackInStockSummaryView/Sent`
        },
        barcodelookup: `${BASEDATAVIEWADDRESS}/barcodelookupview`,
        brandLink: {
            root: `${BASEDATAVIEWADDRESS}/BrandLinkView`
        },
        categoryView: {
            root: `${BASEDATAVIEWADDRESS}/CategoryView`,
            getByParentName: `${BASEDATAVIEWADDRESS}/CategoryView/getByParentName`,
            leafOnlyFilterable: `${BASEDATAVIEWADDRESS}/CategoryView/GetLeafOnlyUsingFilterRequestModel`
        },
        clickAndCollectLocations: {
            available: `${BASEDATAVIEWADDRESS}/ClickAndCollectLocationsView/GetAvailableUsingFilterRequestModel`,
            unavailable: `${BASEDATAVIEWADDRESS}/ClickAndCollectLocationsView/GetUnavailableUsingFilterRequestModel`
        },
        clickAndCollectOrders: {
            root: `${BASEDATAVIEWADDRESS}/clickandcollectorderview`
        },
        colours: `${BASEDATAVIEWADDRESS}/Colours`,
        creditCardPaymentProcessor: {
            root: `${BASEDATAVIEWADDRESS}/CreditCardPaymentProcessor`
        },
        customerList: `${BASEDATAVIEWADDRESS}/CustomerListView`,
        detailedCouponUsage: {
            root: `${BASEDATAVIEWADDRESS}/DetailedCouponUsageView`,
            csv: `${BASEDATAVIEWADDRESS}/DetailedCouponUsageView/GetCsvExport`
        },
        discounts: {
            root: `${BASEDATAVIEWADDRESS}/discountview`,
            csv: `${BASEDATAVIEWADDRESS}/discountview/GetCsvExport`
        },
        discountusage: {
            root: `${BASEDATAVIEWADDRESS}/discountsused`,
            csv: `${BASEDATAVIEWADDRESS}/discountsused/GetCsvExport`
        },
        ebayImportCategories: {
            root: `${BASEDATAVIEWADDRESS}/EbayImportCategoriesView`
        },
        ebayItemSpecifics: {
            root: `${BASEDATAVIEWADDRESS}/EbayItemSpecificsView`
        },
        ebayLog: {
            root: `${BASEDATAVIEWADDRESS}/EbayLogView`,
            getLastWeek: `${BASEDATAVIEWADDRESS}/EbayLogView/GetLastWeekUsingGridRequestModel`,
            getForProduct: `${BASEDATAVIEWADDRESS}/EbayLogView/GetForProductUsingGridRequestModel`
        },
        ebayPlannerView: {
            root: `${BASEDATAVIEWADDRESS}/EbayPlannerView`
        },
        ebayProblemList: {
            root: `${BASEDATAVIEWADDRESS}/EbayProblemListView`
        },
        facetNavigationView: {
            all: `${BASEDATAVIEWADDRESS}/FacetNavigationView/{{SITENUMBER}}`,
            startAtParent: `${BASEDATAVIEWADDRESS}/FacetNavigationView/{{SITENUMBER}}/{{PARENTID}}`
        },
        financeProduct: {
            root: `${BASEDATAVIEWADDRESS}/FinanceProductView`,
            active: `${BASEDATAVIEWADDRESS}/FinanceProductView/GetActiveUsingGridRequestModel`
        },
        fullInventory: `${BASEDATAVIEWADDRESS}/FullInventoryView`,
        googleAnalyticsOrderPosting: {
            root: `${BASEDATAVIEWADDRESS}/GoogleAnalyticsOrderPostingView`
        },
        googleCategories: {
            root: `${BASEDATAVIEWADDRESS}/GoogleCategoriesView`
        },
        inactiveProducts: {
            warehouse: `${BASEDATAVIEWADDRESS}/InactiveProductsView/stockLocation/{{STOCK_LOCATION}}`,
            warehouseCurrentSeason: `${BASEDATAVIEWADDRESS}/InactiveProductsView/stockLocation/{{STOCK_LOCATION}}?currentSeason=true`,
            csv: `${BASEDATAVIEWADDRESS}/InactiveProductsViewExport/GetCsvExport/{{STOCK_LOCATION}}`,
            redirects: `${BASEDATAVIEWADDRESS}/InactiveProductsView/redirects`
        },
        inactiveStyles: {
            root: `${BASEDATAVIEWADDRESS}/InactiveStylesView`
        },
        invalidEbayCategories: {
            filterableByActiveProducts: `${BASEDATAVIEWADDRESS}/invalidebaycategoriesview`
        },
        incorrectPrimaryCategories: {
            root: `${BASEDATAVIEWADDRESS}/incorrectprimarycategoriesview`
        },
        itemFilterQuickApply: {
            root: `${BASEDATAVIEWADDRESS}/ItemFilterQuickApplyView`,
            unassigned: `${BASEDATAVIEWADDRESS}/ItemFilterQuickApplyView/unassigned`
        },
        linkCollections: `${BASEDATAVIEWADDRESS}/LinkCollectionView`,
        linkCollectionEntries: `${BASEDATAVIEWADDRESS}/LinkCollectionEntriesView`,
        orderLinesReport: {
            root: `${BASEDATAVIEWADDRESS}/orderview`,
            csv: `${BASEDATAVIEWADDRESS}/orderview/GetCsvExport`,
            getStarbuysOnly: `${BASEDATAVIEWADDRESS}/orderview/GetForStarBuyUsingGridRequestModel`
        },
        orderDashboardSummaryReport: {
            root: `${BASEDATAVIEWADDRESS}/OrderDashBoardSummaryView`
        },
        orderSummaryReport: {
            root: `${BASEDATAVIEWADDRESS}/ordersummaryview`,
            csv: `${BASEDATAVIEWADDRESS}/orderSummaryView/GetCsvExport`
        },
        outOfStockButActive: {
            root: `${BASEDATAVIEWADDRESS}/OutofStockButActiveView`
        },
        orderViewMerchandiseSummary: {
            root: `${BASEDATAVIEWADDRESS}/orderViewMerchandiseSummaryView`
        },
        paymentActions: {
            getById: `${BASEDATAVIEWADDRESS}/PaymentActionsView/getById`
        },
        payments: {
            root: `${BASEDATAVIEWADDRESS}/PaymentsView`,
            subTotal: `${BASEDATAVIEWADDRESS}/PaymentsView/GetSubTotal`,
            csv: `${BASEDATAVIEWADDRESS}/PaymentsView/GetCsvExport`
        },
        payouts: {
            root: `${BASEDATAVIEWADDRESS}/PayoutView`,
            detail: `${BASEDATAVIEWADDRESS}/PayoutView/GetDetails`,
            csv: `${BASEDATAVIEWADDRESS}/PayoutView/GetCsvExport`,
            detailCsv: `${BASEDATAVIEWADDRESS}/PayoutView/GetDetailCsvExport`,
            detailSummary: `${BASEDATAVIEWADDRESS}/PayoutView/GetDetailsSummary`
        },
        paymentMethods: {
            root: `${BASEDATAVIEWADDRESS}/PaymentMethodsView`
        },
        productCategory: {
            root: `${BASEDATAVIEWADDRESS}/ProductsCategoryView`
        },
        productColourGroup: `${BASEDATAVIEWADDRESS}/ProductColourGroupView`,
        productFilterable: {
            root: `${BASEDATAVIEWADDRESS}/ProductFilterableView`,
            archived: `${BASEDATAVIEWADDRESS}/ProductFilterableView/archived`,
            archivedCsv: `${BASEDATAVIEWADDRESS}/ProductFilterableView/archived/csv`,
            all: `${BASEDATAVIEWADDRESS}/ProductFilterableView/all`,
            collection: `${BASEDATAVIEWADDRESS}/ProductFilterableView/collection`,
            inactive: `${BASEDATAVIEWADDRESS}/ProductFilterableView/inactive`
        },
        productSummary: `${BASEDATAVIEWADDRESS}/productsummaryview`,
        rangeViewer: `${BASEDATAVIEWADDRESS}/rangeviewerview`,
        reviews: {
            root: `${BASEDATAVIEWADDRESS}/reviewview`
        },
        faqsView: {
            root: `${BASEDATAVIEWADDRESS}/faqview`
        },
        relatedPayments: {
            root: `${BASEDATAVIEWADDRESS}/relatedPaymentsView`
        },
        selectCountry: {
            root: `${BASEDATAVIEWADDRESS}/selectCountryView`
        },
        selectCountryCode: `${BASEDATAVIEWADDRESS}/SelectCountryCodeView`,
        selectState: {
            root: `${BASEDATAVIEWADDRESS}/selectStateView`
        },
        simActivationLogStatus: {
            root: `${BASEDATAVIEWADDRESS}/SimActivationLogStatusView`
        },
        simLicenses: `${BASEDATAVIEWADDRESS}/simlicenseview`,
        sizeFilterRule: {
            root: `${BASEDATAVIEWADDRESS}/SizeFilterRuleView`
        },
        starBuys: {
            findAndFilter: `${BASEDATAVIEWADDRESS}/StarBuyView/GetFindAndFilterStarBuys`,
            itemToItem: `${BASEDATAVIEWADDRESS}/StarBuyView/GetItemToItemStarBuys`
        },
        stockLocationList: `${BASEDATAVIEWADDRESS}/stocklocationlistview`,
        stockLocations: {
            root: `${BASEDATAVIEWADDRESS}/StockLocationView`
        },
        supplierIntegrationConfig: {
            root: `${BASEDATAVIEWADDRESS}/SupplierIntegrationConfigView`
        },
        suppressSim: {
            root: `${BASEDATAVIEWADDRESS}/SuppressSim`
        },
        transactionInformation: {
            getById: `${BASEDATAVIEWADDRESS}/TransactionInformationView/getById`
        }
    }
};

export default APIURLS;
